import { QaQuizLeaderboardItem } from "@/types/quiz";
import { getDisplayedTimeAgo } from "@/utils/date";

export const getLeaderboardDetailText = (
  leaderboardType: "overall" | "quiz",
  data: QaQuizLeaderboardItem
) => {
  if (leaderboardType === "overall" && data.resultsCount !== undefined) {
    return `${data.resultsCount} Quiz${
      data.resultsCount === 1 ? "" : "zes"
    } Taken`;
  }

  if (leaderboardType === "quiz" && data.createdAt) {
    return getDisplayedTimeAgo(data.createdAt);
  }
  return "";
};

export const formatSeconds = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
};
